import { Form, Icon } from '@roo/roo';
import download from '../../../../assets/images/download.png';
import React from 'react';
import { useUpdateEffect } from 'ahooks';
import { get } from 'lodash';
import { useSimpleContext } from '../../_context';
import { UploadField } from '../../_components/UploadField';
import { downloadUrls } from '../../../../utils/config';
import { getRuleArray } from '../../../../utils/rules';
import { sendFileLx } from '../../../../utils/lxUtils';
import { useUserContext } from '../../../../components/UserData';

const { Field } = Form;

export const Seal = function (props) {
  const {
    // TODO: 文件模版需要替换 PRD尚未给出
    state: { kechuang_apply_file },
  } = useUserContext((t) => [t.kechuang_apply_file]);

  return (
    <div className='form-patch bc' style={{ paddingLeft: 74 }}>
      <Field
        required={true}
        rule={getRuleArray()}
        name={`officialSealUrl`}
        label='项目申报书'
        layout={'vertical'}
      >
        {(props) => {
          return (
            <div>
              <div className='info normal t-info' style={{ marginBottom: 10 ,wordBreak:'break-all'}}>
                <Icon name='info-circle-o' />
                在模板文件内按照要求填写完成之后，上传有盖章信息的电子扫描件，支持.docx、.pdf，可上传5份文件，单独文件不超过10M。
                申报书模板可在“项目基本信息-项目申报方向”板块下载。
              </div>
             
              <UploadField
                value={Array.isArray(props.value) ? props.value : []}
                handleChange={(fs) => {
                  props.handleChange(fs)
                }}
                maxFiles={5}
                type={'docx'}
              />
            </div>
          );
        }}
      </Field>
      <br />
    </div>
  );
};
